import { prettyPath, prettyUrl } from './service';

export const REACT_APP_FE_URL = process.env.REACT_APP_FE_URL || '';

export const withFEUrl = (path: string) => {
  return prettyUrl(`${REACT_APP_FE_URL}/${prettyPath(path)}`);
};

export const sellerUrlInFe = (path: string) => {
  return prettyUrl(`${REACT_APP_FE_URL}/satici/${prettyPath(path)}`);
};

export const productUrlInFe = (productId: string | number) => {
  return withFEUrl(`/-p-${productId}`);
};

export const brandUrlInFe = (brandSlug: string) => {
  return withFEUrl(`marka/${brandSlug}`);
};

export const publisherUrlInFe = (publisherSlug: string) => {
  return withFEUrl(`yayinevi/${publisherSlug}`);
};

export const safeProductImage = (url: string, width = 300, height = 300) => {
  const doesContainTheSizeVariable = url?.includes('{size}');

  if (!doesContainTheSizeVariable) {
    return url;
  }

  return url?.replace('{size}', `${width}/${height}/`);
};
